var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.3466 34H8.65336C3.87639 34 0 30.1352 0 25.3564V8.65668C0 3.87788 3.87639 0 8.65336 0H25.3466C30.1236 0 34 3.87788 34 8.65668V25.3564C33.9869 30.1352 30.1236 34 25.3466 34Z","fill":"#CEAAFF","key":0}),React.createElement("path",{"d":"M9.71484 12.6287H24.2863M9.71484 22.3429H24.2863M9.71484 17.4858H24.2863","stroke":"#8126FF","strokeWidth":"2.42857","strokeLinecap":"round","key":1})]);
}

Burger.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
